import { inject as m, onBeforeUnmount as g } from "vue";
import u, { cookListener as p } from "../lib/ListenerManager.js";
const t = Symbol("manager"), d = {
  install(e) {
    const n = new u();
    e.provide(t, n);
  }
};
function w() {
  const e = m(t);
  if (!e) throw new Error("ListenersPlugins was not installed.");
  const n = Symbol(), o = (r, s, i) => {
    const {
      target: a,
      listener: c,
      options: l
    } = p(s);
    return e.listen({
      target: a,
      type: r,
      listener: c,
      options: i ?? l,
      context: n
    });
  };
  return g(() => {
    e.clear(n);
  }), { listen: o };
}
export {
  d as default,
  t as managerKey,
  w as useListenerManager
};
